import {ConstantsService} from '../../fidelidade/ConstantsService';
import {RotaGuardClient} from '../../guards/auth-loja.guard';
import {criarCatalogoMenuV2, FuncaoMenuV2} from './menu-v2.catalogo';

/** Monta o catálogo de funções a partir do usuário logado e da empresa; usado pelos dois menus. */
export function criarCatalogoParaUsuario(usuario: any, empresa: any, constants: ConstantsService, servidorImpressaoAtivo: boolean): FuncaoMenuV2[] {
  const u = usuario;
  const permissoes: {[nome: string]: boolean} = {
    loja: RotaGuardClient.gerenciaLoja(u), usuarios: RotaGuardClient.gerenciarUsuariosLoja(u),
    produtos: RotaGuardClient.cadastrarProdutos(u), estoque: RotaGuardClient.gerenciarEstoque(u),
    contatos: RotaGuardClient.cadastrarContatos(u), notificacoes: RotaGuardClient.cadastrarNotificacoes(u),
    caixa: RotaGuardClient.operarCaixa(u), kds: RotaGuardClient.operadorKDS(u),
    relatorios: RotaGuardClient.visualizaRelatorios(u), contaPay: RotaGuardClient.visualizarContaCellcoin(u),
    editarPedido: RotaGuardClient.editarPedido(u), alterarStatus: RotaGuardClient.alterarStatusPedido(u),
    cancelarPedido: RotaGuardClient.cancelarPedido(u), pontuar: RotaGuardClient.adicionarPontosFidelidade(u),
    resgatar: RotaGuardClient.resgatarBrindesFidelidade(u)
  };
  return criarCatalogoMenuV2({empresa: empresa || {}, garcom: !!u?.garcom,
    admin: !!u?.admin, superadmin: !!u?.superadmin,
    somenteCardapio: constants.possuiApenasModulo(empresa, 'cardápio'),
    servidorImpressaoAtivo,
    permissao: nome => !!permissoes[nome],
    modulo: nome => constants.possuiModulo(empresa, nome),
    recurso: nome => constants.possuiRecurso(empresa, nome)});
}
